export default {"src":"/_next/static/media/wavy-top.ddc759ce.svg","height":25,"width":1678,"blurWidth":0,"blurHeight":0};